import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateAccounts } from '@/modules/Account/gql/account.gql'
import { Account } from '@/modules/Account/interfaces/account'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchAccount extends Vue {
  candidatesAccount: Account[] = []

  get candidatesAccountNameOptions () {
    return this.candidatesAccount.map(item => {
      return item.name
    })
  }

  get candidatesAccountOptions () {
    return this.candidatesAccount.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async getCandidateAccounts (val: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateAccounts,
        variables: {
          filter: {
            name: val
          },
          paging: {
            offset: 0,
            limit: -1
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesAccount = result.data.getAccounts.accounts
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
